function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.0429688 7.54315L7.12163 0.464488L7.82874 1.1716L0.750076 8.25026L0.0429688 7.54315Z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.12207 8.25027L0.0434067 1.17161L0.750514 0.464504L7.82918 7.54317L7.12207 8.25027Z",
  fill: "currentColor"
});

function SvgIcClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgOCA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMDQyOTY4OCA3LjU0MzE1TDcuMTIxNjMgMC40NjQ0ODhMNy44Mjg3NCAxLjE3MTZMMC43NTAwNzYgOC4yNTAyNkwwLjA0Mjk2ODggNy41NDMxNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMTIyMDcgOC4yNTAyN0wwLjA0MzQwNjcgMS4xNzE2MUwwLjc1MDUxNCAwLjQ2NDUwNEw3LjgyOTE4IDcuNTQzMTdMNy4xMjIwNyA4LjI1MDI3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgoK";
export { SvgIcClose as ReactComponent };